import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import NewReleasesIcon from "@material-ui/icons/NewReleases";
import { useStyles } from "../SideDrawer/NavListItems/styles";
import useNotificationFeedbackSettings from "../../hooks/useNotificationFeedbackSettings";
import useDisplayPeriodTimer from "../../hooks/useDisplayPeriodTimer";
import { shouldShowReleaseNotesButton } from "../../utils/notificationFeedbackVisibility";

const ReleaseNotesButton = ({ isIssueValidationOnlyUser }) => {
  const classes = useStyles();
  const { settings, loading, error } = useNotificationFeedbackSettings();

  const isWithinDisplayPeriod = useDisplayPeriodTimer(
    settings?.displayPeriodStart,
    settings?.displayPeriodEnd
  );

  const shouldShow = shouldShowReleaseNotesButton({
    releaseNotesEnabled: settings?.releaseNotesEnabled,
    isWithinDisplayPeriod,
    releaseNotesUrl: settings?.releaseNotesUrl,
    isIssueValidationOnlyUser,
    hasSettings: !loading && !error && settings != null,
  });

  if (!shouldShow) return null;

  const handleClick = () => {
    window.open(settings.releaseNotesUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <ListItem
      button
      className={`${classes.navLink} release-notes-button`}
      onClick={handleClick}
      aria-label="Release Notes"
    >
      <ListItemIcon>
        <span style={{ position: "relative", display: "inline-flex" }}>
          <span style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 14,
            height: 14,
            borderRadius: "50%",
            backgroundColor: "#ffffff",
          }} />
          <NewReleasesIcon style={{ color: "#e70022", position: "relative" }} fontSize="large" />
        </span>
      </ListItemIcon>
      <ListItemText primary="What's New" />
    </ListItem>
  );
};

export default ReleaseNotesButton;
